import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { ISubject } from '../../../core/models/subject';

interface NewSubjectState {
  module: string | null ;
  subjects: ISubject[];
  selectedSubjects: string[];
  selectOptions: { label:string, value: string }[];
  setModule: (module: string | null) => void;
  setSelectOptions: (options: { label:string, value: string }[]) => void;
  setSubjects: (subjects: ISubject[]) => void;
  setSelectedSubjects: (subjects: string[]) => void;
  resetSubjects: () => void;
}

export const useNewSubjectStore = create<NewSubjectState>()(
  persist(
    (set) => ({
      module: null,
      subjects: [],
      selectedSubjects: [],
      selectOptions: [],
      setModule: (module: string | null) => set({ module }),
      setSelectOptions: (options: { label:string, value: string }[]) => set({ selectOptions: options }),
      setSubjects: (subjects: ISubject[]) => set({ subjects }),
      setSelectedSubjects: (subjects: string[]) => set({ selectedSubjects: subjects }),
      resetSubjects: () => set({ subjects: [], selectedSubjects: [] })
    }),
    {
      name: 'new-discipline-subject',
    }
  )
);